import styled from "styled-components";
import { Table, Icon, Modal, Col } from "antd";
import { GhostButtonComponent, DataValue, PageSectionHeading, SectionSpacing, SectionSubHeading, SummaryLabel, SummaryData, PrimaryButtonComponent, UnderlineLink, PagesHeading } from "../../../../CommonComponents/commonStyles";

export const RecommendExchangeSection = styled.div`
  //used to override common styles only for RecommendExchangeSection
  ${PagesHeading}{
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
  ${PageSectionHeading}{
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    line-height: 1.25;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    @media only screen and (max-width: 767px) {
      font-size:20px;
      line-height: 1.5;
    }
  }
  ${SectionSpacing}{
    margin: 50px 0;
    @media only screen and (max-width: 767px) {
      margin: 40px 0;
    }
  }
  ${SectionSubHeading}{
    margin: 15px 0 30px;
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    @media only screen and (max-width: 767px) {
      margin: 5px 0 20px;
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  ${SummaryLabel}{
    letter-spacing: normal;
    @media only screen and (max-width: 767px) {
      padding: 0 10px 0 0;
      line-height: 1.5;
    }
  }
  ${SummaryData}{
    font-size: ${props => props.theme.fontSize.h4};
    line-height: normal;
    @media only screen and (max-width: 767px) {
      text-align: right;
      line-height: normal;
      font-size: ${props => props.theme.fontSize.h5};
      word-break: break-all;
    }
  }
  a{
    color: ${props => props.theme.fontColors.primary};
    text-decoration: underline;
  }
  .mb-15{
    margin-bottom: 15px;
  }
  input{
    &:placeholder {      
      color: ${props => props.theme.colors.border} !important;
      @media only screen and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
      }
    }
    &:focus {
      outline: none;
    }
  }
`;

export const CustomSectionSpacing = styled.div`
margin: ${props => props.isPrint ? '10px 0' : '50px 0' };
@media only screen and (max-width: 767px) {
  margin: 40px 0px 0px 0;
}
`;

export const ButtonLoader = styled.img`  
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 25px;
  height: 25px;
`;

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  line-height: 1.38;
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Heading = styled(DataValue)`
  line-height: 1.6rem;
`;

export const ImpactContainer = styled.div`
    margin-top: 170px;
`;

export const ColSpacing = styled(Col)`
  margin-left: 20px;
  @media (max-width: 991px) {
    margin-left: 0px;
  }
`;

export const AlignItems = styled.div`
  align-items: center;
  justify-content: space-between;
  /* width: 750px; */
  @media only screen and (max-width: 767px) {
    display: block;
    width: 320px;
  }
`;

export const CheckboxWrapper = styled.div`
  margin-left: 25px;
  @media only screen and (max-width: 767px) {
    margin-top: 20px;
  }
`;

export const CheckboxLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.25;
  letter-spacing: ${props => props.theme.letterSpacing.point7};
  color: ${props => props.theme.colors.dropdownArrow};
`;

export const ColumnTitleMobile = styled.div`
  display: none;
  margin: 0 0 5px 0;
  @media only screen and (max-width: 991px) {
    display: block;          
  }
`;

export const ColumnValue = styled.div`
  font-size: ${props => props.theme.fontSize.primary};  
  line-height: 1.5;
  @media only screen and (max-width: 991px) {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};        
    color: ${props => props.theme.fontColors.headingColor};
    i.anticon-caret-up{
      color: ${props => props.theme.fontColors.textColor};
    }
  }
`

export const PoolTable = styled(Table)`
  .ant-table {
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
      table{
        display: flex;            
        flex-direction: column;
        width: 100%;
      }      
    }    
    .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      & > tr {
        background-color: #ffffff;
        border-top: solid 1px #d4d4d4;
        border-bottom: solid 1px #d4d4d4;
      }
      & > tr > th {
        padding: 16px 10px;
        color: ${props => props.theme.fontColors.headingColor};        
        background: ${props => props.theme.backgroundColor.layoutLight};
        font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        line-height: ${props => props.theme.lineHeight.tableFont};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
        @media only screen and (max-width: 991px) {          
          &.hide-col-title-in-mobile{
            display: none;
          }
        }
      }
    }
    .ant-table-tbody {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      & > tr > td {
        padding: 10px;
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        color: ${props => props.theme.fontColors.textColor};
        letter-spacing: ${props => props.theme.letterSpacing.point6};
        border-bottom: none;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
      }
    }
    .ant-table-column-title {
      transform: none;
    }
    .ant-table-content{           
      @media only screen and (max-width: 991px) {
        width: 100%;
        .ant-table-thead > tr{
          border: none;
          padding: 0;
        }
        tr{
          display: flex;
          padding: 0 15px;          
          flex-wrap: wrap;
          outline: 1px solid ${props => props.theme.colors.white};
          border-bottom: 1px solid ${props => props.theme.backgroundColor.layoutDark};
          &:hover{
            td{
              background: transparent !important;
            }
          }
          td{
            border-bottom: 1px solid ${props => props.theme.border.pill};
            &:nth-last-child(-n+2){
              border-bottom: none;
            }
            &:nth-last-child(2):nth-child(odd){
              border-bottom: 1px solid ${props => props.theme.border.pill};
            }
          }
          th,td{         
            width: 50%; 
            padding:10px 10px 10px 0px;                        
            &.cell-w100{
              width: 100%; 
            }
            &.cell-w33{
              width: 33.33%; 
            }         
          }
          th.radio-input-col{
            width: auto;
            background-color: transparent;
            padding: 10px 15px 20px 0;
            border: none;
            font-family: ${props => props.theme.fontFamily.helveticaNeue}; 
            &:last-child{
              padding-right: 0;
            }
            .ant-table-column-title{
              display: flex;
            }
          }
        }
        .investment-pool-title{
          width: 100%;
          font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
          color: ${props => props.theme.fontColors.headingColor};
          letter-spacing: ${props => props.theme.letterSpacing.zero} ;
          padding-bottom: 5px;
          border: none !important;
        }         
      }
    }
  }  
`;

export const BackIcon = styled(Icon)`
  display: inline-block;
  position: relative;
  transition: left 0.2s;
  @media only screen and (max-width: 990px) {
    left: 5px;
  }
  @media only screen and (max-width: 576px) {
    left: 5px;
  }
`;

export const BackButton = styled(GhostButtonComponent)`
  &:hover ${BackIcon} {
    left: -5px;
  }
`;

export const NavigationButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 15px -15px;
  @media only screen and (max-width: 767px) {
    margin: 7px -7px;
  }
  button{
    margin: 15px;
    width: auto;
    max-width: 100%;    
    @media only screen and (max-width: 767px) {
      margin: 7px;
      width: 50%;
      &.sm-btn-w100{
        width: 100%;
      }
    }
  }
`;

export const NavigationGroupButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 15px -15px;
  button {
    margin: 0 10px 16px 0 !important;
  }
`;

export const NavigationBtnContainer = styled.div`
  justify-content: space-between;
  margin: 50px 0 0;
  & > div {
    display: flex;
    & button:nth-child(1) {
      margin-right: 1.8rem;
    }
  }
  ${PrimaryButtonComponent},
  ${GhostButtonComponent}{
    @media only screen and (max-width: 990px) {
      width: ${props => props.theme.buttonWidth.primaryButton};
    }
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }
  @media only screen and (max-width: 767px) {
    margin: 40px 0 0;
    flex-flow: wrap;
    & > button  {
      font-size: ${props => props.theme.fontSize.primary};
    }
    & > button:first-child {
      flex-basis: 100%;
      margin-top: 0;      
    }
    & > button {
      flex-basis: 100%;
      margin-top: 15px;
    }
  }
`;

const FromToTableFooter = styled.div`
  border-top: solid 2px ${props => props.theme.border.raeCardFooter};
  border-bottom: solid 2px ${props => props.theme.border.raeCardFooter};
  padding: 0.75rem 0;
  color: ${props => props.theme.fontColors.raeCardFooter};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: ${props => props.theme.letterSpacing.pont5};
  & > div {
    margin-bottom: 0.25rem;
  }
`;

export const FromCardFooter = styled(FromToTableFooter)``;

export const ToCardFooter = styled(FromToTableFooter)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1024px) {
    margin: 0 -25px;
    padding: 0.75rem 1.5625rem;
  }
  @media (max-width: 576px) {
    margin: 0 -20px;
    padding: 0.75rem 1.25rem;
  }
`;

export const TotalFixedText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.6px;
  font-size: ${props => props.theme.fontSize.tertiary};
`;

export const TradeCutOffInfo = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: normal;
  color:${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    color:${props => props.theme.fontColors.headingColor};
  }
`;

export const InvestmentOptionFixGridVal = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: normal;
  text-transform: capitalize;
`;

export const ErrorMessage = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: red;
`;
export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: #505050;
    text-align: center;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }
  .ant-modal-header {
    padding-top: 30px;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    text-align: center;
  }

  .ant-modal-footer {
    padding: 6px 16px 16px 16px;
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 292px;
    border-radius: 0;
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #fff;
    background-color: #006778;
    @media only screen and (min-width: 320px) and (max-width: 374px) {
      width: 252px;
    }
  }

  .ant-modal-footer button + button {
    @media only screen and (min-width: 320px) and (max-width: 347px) {
      margin-left: 0;
    }
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff!;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #006778;
    border: 0px solid transparent;
    text-decoration: underline;
    &:focus {
      box-shadow: 0 0 0 0.15rem #006778;
    }
  }
  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: #006778;
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn-primary:focus {
    box-shadow: 0 0 0 0.15rem #006778;
  }
`;

export const PoolModal = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: #505050;
    text-align: center;
   // font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
  }
  .ant-modal-header {
    padding: 30px 0 13px 0;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    padding: 24px 48px 30px 33px;
    text-align: center;
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #006778;
    border: 0px solid transparent;
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: #006778;
    text-decoration: underline;
  }
`;

export const RecommendAnExchangeWrapper = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }
`;

export const RecommendAnExchangeHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};  
  line-height: 1.14;
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {    
    font-size: 36px;
    margin-bottom: 20px;
    line-height: 1.17;    
  }
`;
export const RecommendAnExchangesHeading = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};  
  line-height: 1.14;
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {    
    font-size: 36px;
    margin-bottom: 20px;
    line-height: 1.17;    
  }
`;

export const SectionHeading = styled.h4`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin: 0 0.5rem 0 0;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const HrDivider = styled.div`
  border: 1px solid #eee;
  height: 50px;
  margin-left: 45px;
  margin-right: 20px;
  margin-bottom: 0.625rem;
  @media only screen and (max-width: 767px) {
    display: ${props => props.hideInMobile ? 'none' : 'block'};
  }
`
export const PrintDiv = styled.div`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  @media only screen and (max-width: 767px) {
    margin: 15px 0 0 0;
  }
`;

export const PrintSection = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 576px) {
    display: block;
  }
`;

export const PrintButton = styled.div` 
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  color: #006778;
  margin-left: 10px;
  text-decoration: underline;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CustomTableForPrint = styled.table`
  width: 100%;
  font-size: ${props => props.theme.fontSize.primary};
  thead tr { 
    border-bottom: solid 1px ${props => props.theme.border.tableBorder};
  }
  thead tr, tbody tr {
    width: 100%;
  }
  thead tr th {
    width: 50%;
    font-weight: normal;
  }
  thead tr th div{
    width: 100%;
    padding: 16px 10px;
    color: ${props => props.theme.fontColors.headingColor};        
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
  tbody tr td, tbody tr td div {
    width: 50%;
    padding: 5px 10px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.textColor};
    letter-spacing: ${props => props.theme.letterSpacing.point6};
    border-bottom: none;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }
`;